import React, { Component } from 'react'
// import {connect} from 'react-redux'
import { Box } from 'reactjs-admin-lte'
import { Button, ButtonToolbar, FormGroup, Row, Col, FormControl, ControlLabel, DropdownButton, MenuItem, InputGroup, Modal } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import TyreStore from 'stores/TyreStore'
import StockStore from 'stores/StockStore'
import WorkdocStore from 'stores/WorkdocStore'
import CKAutocomplete from 'component/element/CKAutocomplete'
import InputNumber from 'rc-input-number'
import RemarkRecordModal from 'component/element/RemarkRecordModal'
import IframeModal from 'component/element/IframeModal'
import ConfirmPopup from 'component/element/ConfirmPopup'
import Select from 'react-select'
import ReportAssetVehiclePage from './report-asset-vehicle-page/ReportAssetVehiclePage'
const NotificationSystem = require('react-notification-system')
const DEFAULT_ROW = 10
class TyreRepairInsideDoc extends Component {
    constructor(props) {
       super(props)
      
       this.state = {
            loading:false,
            trNo:undefined,
            customerList:[],
            stockApproverList:[],
            car_registration_no_list:[],
            doc:{response_by:'',request_by:'',tyre_repair_no:'',seq_no:'',added_date:'',vehicle_id:'',amount:'',trash_flag:'',added_by:'',description:'',type_repair_no:'',vehicle_registration_no:'',tyre_repair_type:''},
            itemlist:[],
            showRemark:false,
            showConfirm:false,
            msgConfirm:'',
            showAssetVehicle:false,
            rowSelect:null
        }
    }
  
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
    }

    componentWillReceiveProps(newProps) {
        if (newProps.onShow&&this.props.onShow!==newProps.onShow){
            this.loadWorkdocAutocompleteOfficer()
            this.loadWorkdocAutocompleteStockApprover()
            this.loadCarRegistrationNo()
        }    
    }  

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    setDocAmount() {
        let {itemlist} = this.state
        let _amount = 0
        itemlist.forEach((item,index)=>{
            let amount = (item.amount===''||item.amount===null||item.amount===undefined||isNaN(item.amount)?0:item.amount)
            _amount += amount*1
        })
        return _amount
    }

    newEmptyRow(number) {
        return new Array(number).fill(null).map((item,index) => {
            return {
                amount:'',
                brand:'',
                detail:'',
                invoice_date:'',
                mileage:'',
                model:'',
                seq:'',
                serial_no:'',
                tyre_repair_item_id:0,
                tyre_repair_no:'',
                tyrecode:'',
                vehicle_id:'',
                vehicle_registration_no:'',
                wheel_at:''
            }
        })
    }
    
    loadNewDoc() {
        let {itemlist,doc,trNo} = this.state
        this.setState({loading:true})
        TyreStore.loadNewReportRepairInsideDoc((result)=>{
            doc = Object.assign(doc,result.data.doc)
            trNo = doc.tyre_repair_no
            itemlist = result.data.itemlist
            itemlist = this.newEmptyRow(DEFAULT_ROW) 
            this.setState({loading:false,doc:doc,itemlist:itemlist,trNo:trNo})
        })
    }

    loadData(trNo) {
        let {itemlist,doc} = this.state
        this.setState({loading:true,trNo:trNo})
        TyreStore.loadReportRepairInsideDoc(trNo,(result)=>{
            doc = Object.assign(doc,result.data.doc)
            doc.amount = this.setDocAmount()
            itemlist = result.data.itemlist
            if (itemlist.length===0) {
                itemlist = this.newEmptyRow(DEFAULT_ROW)
            } else {
                if (itemlist.length<DEFAULT_ROW) {
                    itemlist = itemlist.concat(this.newEmptyRow(DEFAULT_ROW-itemlist.length))
                }
            }    
            this.setState({loading:false,doc:doc,itemlist:itemlist})
        })
    }
    
    loadWorkdocAutocompleteOfficer() {
        let officer = []
        WorkdocStore.loadWorkdocAutocompleteOfficer((result)=>{
            result.data.forEach(element => {
                officer.push({
                    id: element.Value,
                    label: element.Name,
                    emp_id: element.employee_id
                })
            })
          this.setState({customerList:officer})
        })  
    }  
    
    loadWorkdocAutocompleteStockApprover() {
        let approver = []
        WorkdocStore.loadWorkdocAutocompleteStockApprover((result)=>{
            result.data.forEach(element => {
                approver.push({
                    id: element.Value,
                    label: element.Name,
                    emp_id: element.employee_id
                })
            })
          this.setState({stockApproverList:approver})
        })  
    }
    
    loadCarRegistrationNo() {
        let {doc} = this.state
        let car = []
        StockStore.loadCarRegistrationNo(doc.vehicle_registration_no,(result)=>{
            result.data.forEach(element => {
                car.push({
                    id: element.Value,
                    label: element.Name,
                    car_info: element.car_info,
                    work_no :element.work_no
                })
            })
            this.setState({car_registration_no_list:car})
        })
    }

    onRowAdd(number) {
        let {itemlist} = this.state
        itemlist = itemlist.concat(this.newEmptyRow(number))
        this.setState({itemlist:itemlist})
    }

    onSaveClick() {
        this.saveTRDoc()
    }

    saveTRDoc() {
        let {doc,itemlist} = this.state
        let postData = {doc:doc,itemlist:itemlist}
        this.setState({loading:true})
        TyreStore.saveTyreRepairInsideDoc(this.state.trNo,postData,(result)=>{
            if (result.status==='OK') {
                doc.seq_no = result.seq_no
                this.setState({loading:false,doc:doc})
                this._notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message:'ทำการบันทึกรายการใบงานซ่อมยางภายในเรียบร้อย',
                    level:'info',
                    position:'tc'
                })
            }
        },()=>{
            this.setState({loading:false})
            this._notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message:'ทำการบันทึกรายการล้มเหลว',
                level:'error',
                position:'tc'
            })
        })
    }

    onCloseClick() {
        if (this.props.onCloseClick!==undefined)
            this.props.onCloseClick()
    }

    onTextChange(field,e) {
        let {doc} = this.state
        doc[field] = e.target.value
        this.setState({doc:doc})
        if (field==='vehicle_registration_no')
            this.loadCarRegistrationNo()
    }

    onTextSelect(field,e) {
        let {doc} = this.state
        doc[field] = e
        this.setState({doc:doc})
    }

    onRowTextChange(index,field,e) {
        let {itemlist,doc} = this.state
        itemlist[index][field] = (field==='mileage'||field==='amount'?e:e.target.value)
        doc.amount = this.setDocAmount()
        this.setState({itemlist:itemlist,doc:doc})
    }

    onDeleteRowClick(index) {
        let {itemlist,doc} = this.state
        itemlist.splice(index,1) 
        this.setState({itemlist:itemlist,doc:doc})
        this.saveTRDoc()
    }

    onDropdownSelect(e) {
        if (e==='2') {
            this.setState({showConfirm:true,msgConfirm:'ยืนยันการทำรายการเปลี่ยนสถานะเป็นจ่ายเงินแล้วหรือไม่ ?'})
        } else if (e==='3') {
            this.setState({showConfirm:true,msgConfirm:'ยืนยันการทำรายการยกเลิกใบงานซ่อมยางภายในหรือไม่ ?'})
        } else if (e==='4') {
            this.setState({showRemark:true})
        }
    }

    onConfirmClick() {
        let status = ''
        if (this.state.msgConfirm==='ยืนยันการทำรายการเปลี่ยนสถานะเป็นจ่ายเงินแล้วหรือไม่ ?') {
            status = '1'
        } else if (this.state.msgConfirm==='ยืนยันการทำรายการยกเลิกใบงานซ่อมยางภายในหรือไม่ ?') {
            status = '0'
        }
        let postData = {tyre_repair_no:this.state.trNo,status:status}
        TyreStore.updateTyreRepairInsideDoc(status,postData,(result)=>{
            if (result.status==='OK') {
                let _msg = ''
                if (status==='1')
                    _msg = 'เปลี่ยนสถานะเป็นจ่ายเงินแล้ว '
                else
                    _msg = 'ยกเลิก'
                
                this._notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message:'ทำการ'+_msg+'ใบงานซ่อมยางภายในเลขที่ '+this.state.trNo+' เรียบร้อย',
                    level:'info',
                    position:'tc'
                })
                this.setState({showConfirm:false,msgConfirm:''})
            }
        },()=>{
            this._notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message:'ทำรายการล้มเหลว',
                level:'error',
                position:'tc'
            })
            this.setState({showConfirm:false,msgConfirm:''})
        })
    }

    onPrintClick(){
        let {trNo} = this.state
        let url = './pdf/v2?startPage=PrintTyreRepairDoc&trNo='+trNo
        if (process.env.NODE_ENV === "development") {
            url = '?startPage=PrintTyreRepairDoc&trNo='+trNo
        }
        this.refs.iframe.loadUrl(url)
    }

    onRemarkDeleteRecordClick() {
        this.setState({loading:true})
        TyreStore.delTyreRepairInsideDoc(this.state.trNo,(result)=>{
            if (result.status==='OK') {
                this._notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message:'ทำการลบรายการใบงานซ่อมยางภายในเลขที่ '+this.state.trNo+' เรียบร้อย',
                    level:'info',
                    position:'tc'
                })
                this.setState({loading:false,showRemark:false})
                this.onCloseClick()
            }
        },()=>{
            this._notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message:'ทำการลบรายการล้มเหลว',
                level:'error',
                position:'tc'
            })
            this.setState({loading:false,showRemark:false})
        })
    }

    onTyreRepairTypeChange(e) {
        let {doc} = this.state
        if (e===null) {
            doc.tyre_repair_type = ''
        } else {
            doc.tyre_repair_type = e.value
        }
        this.setState({doc:doc})
    }

    onSerialNoKeyPress(item,index) {
        let {itemlist} = this.state
        TyreStore.loadSearchTyreSerial(item.serial_no,(result)=>{
            if (result.data.length>0) {
                let checkDup = itemlist.findIndex(x=>x.serial_no===result.data[0].serial_no&&x.tyre_repair_item_id===result.data[0].itemnum)
                if (checkDup===-1) {
                    itemlist[index].amount = result.data[0].price_per_unit*result.data[0].quantity
                    itemlist[index].brand = result.data[0].tyre_brand
                    itemlist[index].detail = result.data[0].description
                    itemlist[index].invoice_date = ''
                    itemlist[index].mileage = result.data[0].tyre_mileage
                    itemlist[index].model = result.data[0].tyre_model
                    itemlist[index].seq = ''
                    itemlist[index].serial_no = result.data[0].serial_no
                    itemlist[index].tyre_repair_item_id = result.data[0].itemnum
                    itemlist[index].tyre_repair_no = ''
                    itemlist[index].tyrecode = ''
                    itemlist[index].vehicle_id = ''
                    itemlist[index].vehicle_registration_no = ''
                    itemlist[index].wheel_at = ''
                } else {
                    this._notificationSystem.addNotification({
                        title:'แจ้งเตือน',
                        message:'ไม่สามารถเพิ่มรายการได้ เนื่องจากมียางหมายเลข "'+result.data[0].serial_no+'" นี้อยู่แล้ว',
                        level:'error',
                        position:'tc'
                    })
                }    
            }    
            this.setState({itemlist:itemlist})
        })
    }

    onRegistrationSearchClick(index) {
        this.setState({showAssetVehicle:true,rowSelect:index})
    }

    onAssetVehicleSelect(item) {
        let {rowSelect,itemlist} = this.state
        let index = rowSelect
        itemlist[index].vehicle_id = item.vehicle_id
        itemlist[index].vehicle_registration_no = item.vehicle_registration_no
        this.setState({showAssetVehicle:false,rowSelect:null})
    }

    renderHeaderRow() {
        return (
            <div>           
                <Row>
                    <Col md={2}>
                        <FormGroup>
                            <ControlLabel>เลขที่เอกสาร</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <FormControl type="text" placeholder="<เลขที่ถูกสร้างอัตโนมัติ>" className="input-dark" />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <ControlLabel>วันที่</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <FormControl type="text" placeholder="" className="input-dark" value={this.state.doc.added_date} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            <ControlLabel>ผู้ขอเบิก</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            <CKAutocomplete
                                top={'-34px'}
                                items={this.state.customerList}
                                value={this.state.doc.request_by}
                                onChange={this.onTextChange.bind(this, 'request_by')}
                                onSelect={this.onTextSelect.bind(this, 'request_by')}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            <ControlLabel>ชื่อผู้อนุมัติ</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup
                            controlId={null}
                            validationState={null}
                        >
                            <CKAutocomplete
                                top={'-34px'}
                                items={this.state.customerList}
                                value={this.state.doc.response_by}
                                onChange={this.onTextChange.bind(this, 'response_by')}
                                onSelect={this.onTextSelect.bind(this, 'response_by')}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <FormGroup>
                            <ControlLabel>ประเภทงานซ่อม</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Select
                                placeholder='--- เลือกประเภท ---'
                                searchable={false}
                                clearable={true}
                                value={this.state.doc.tyre_repair_type}
                                options={[{label:'เปลี่ยนยาง',value:'change_tyre'},{label:'ซ่อมยางภายใน',value:'fix_tyre'},{label:'วัดดอกยาง',value:'treaddepth_tyre'},{label:'หล่อดอก',value:'retread_tyre'}]}
                                onChange={this.onTyreRepairTypeChange.bind(this)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <ControlLabel>คำอธิบาย</ControlLabel>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <FormControl value={this.state.doc.description} onChange={this.onTextChange.bind(this, 'description')} />
                        </FormGroup>
                    </Col>
                </Row>    
            </div>
        )          
    }
    
    renderRowData() {
        let {itemlist} = this.state
        if (itemlist.length===0) {
            return(<tr><td colSpan={9}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                itemlist.map((item,index)=>
                    <tr key={index}>
                        <td className='text-center'>{index+1}</td>
                        <td className='text-center'>
                            <FormControl className='text-center' onChange={this.onRowTextChange.bind(this,index,'serial_no')} value={item.serial_no} onKeyPress={this.onSerialNoKeyPress.bind(this,item,index)} />
                        </td>
                        <td className='text-center'>
                            <FormControl className='text-center' onChange={this.onRowTextChange.bind(this,index,'brand')} value={item.brand} />
                        </td>
                        <td className='text-center'>
                            <FormControl className='text-center' onChange={this.onRowTextChange.bind(this,index,'model')} value={item.model} />
                        </td>
                        <td className='text-center'>
                            <InputGroup>
                                <FormControl className='text-center' onChange={this.onRowTextChange.bind(this,index,'vehicle_registration_no')} value={item.vehicle_registration_no} />
                                <InputGroup.Addon onClick={this.onRegistrationSearchClick.bind(this,index)}><FontAwesome name='search' /></InputGroup.Addon>
                            </InputGroup>
                        </td>
                        <td className='text-center'>
                            <FormControl className='text-center' onChange={this.onRowTextChange.bind(this,index,'wheel_at')} value={item.wheel_at} />
                        </td>
                        <td className='text-center'>
                            <InputNumber
                                className='input-number-format-form-control text-center'
                                value={item.mileage} 
                                onChange={this.onRowTextChange.bind(this,index,'mileage')}
                                formatter={value =>
                                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            />
                        </td>
                        <td className='text-left'>
                            <FormControl onChange={this.onRowTextChange.bind(this,index,'detail')} value={item.detail} />
                        </td>
                        <td className='text-center'>
                            <Button bsStyle={'danger'} onClick={this.onDeleteRowClick.bind(this,index)}><FontAwesome name='trash'/></Button>
                        </td>
                    </tr>
                )
            )
        }
    }

    renderTable() {
        let {doc} = this.state
        return(
            <div className='table-responsive'>
                <table className="table table-hover table-bordered-solid" style={{minWidth:'1280px',marginBottom:'0'}}>
                    <thead>
                        <tr>
                            <th style={{width:'50px'}} className='text-center'>ลำดับ</th>
                            <th style={{width:'100px'}} className='text-center'>หมายเลขยาง</th>
                            <th style={{width:'90px'}} className='text-center'>ยี่ห้อ</th>
                            <th style={{width:'90px'}} className='text-center'>รุ่น</th>
                            <th style={{width:'100px'}} className='text-center'>ทะเบียนรถ</th>
                            <th style={{width:'70px'}} className='text-center'>ล้อที่</th>
                            <th style={{width:'90px'}} className='text-center'>เลขไมล์</th>
                            <th style={{width:'110px'}} className='text-center'>รายการซ่อม</th>
                            <th style={{width:'30px'}} className='text-center'>ลบ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderRowData()}
                    </tbody>
                    <tfoot>
                        <tr>            
                            <th colSpan={7} className='text-right'>รวมเป็นเงิน</th>
                            <th className='text-right'>{this.getNumberFormat(doc.amount)}</th>
                            <th className='text-right'></th>
                        </tr>
                    </tfoot>    
                </table>
            </div>
        )    
    }

    renderNewItemButton() {
        return(
            <Row style={{marginTop:'10px'}}>
                <Col md={12}>
                    <ButtonToolbar>
                        <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;เพิ่มรายการ</Button>
                        <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;เพิ่ม 10 รายการ</Button>
                    </ButtonToolbar>        
                </Col>
            </Row>
        )
    }

    renderRemark() {
        return (
            <Row style={{marginTop:'10px'}}>
                <Col lg={3} md={3} sm={6}>
                    <FormGroup
                        controlId={null}
                        validationState={null}
                    >
                        <ControlLabel>หมายเหตุ</ControlLabel>
                        <FormControl value={this.state.doc.remark===null?'':this.state.doc.remark} componentClass="textarea" style={{height:'150px'}} onChange={this.onTextChange.bind(this,'remark')} />            
                    </FormGroup>
                </Col>  
            </Row>
        )
    }

    renderAssetVehicleModal() {
        return(
            <Modal
                show={this.state.showAssetVehicle}
                onHide={()=>{this.setState({showAssetVehicle:false,rowSelect:null})}}
                dialogClassName="midwidth-dialog"
            >
                <Modal.Header closeButton>
                    <Modal.Title>เลือกรายการยานพาหนะ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ReportAssetVehiclePage
                        mode='tyre-repair-inside-doc'
                        onRowSelect={this.onAssetVehicleSelect.bind(this)}
                    />
                </Modal.Body>
            </Modal>        
        )
    }

    render() {
        let {loading,trNo,doc} = this.state
        return(
            <div>
                <Box loading={loading}>
                    <Box.Header className='text-center'>
                        <Box.Title>
                            {'ใบงานซ่อมยางภายในเลขที่ '+trNo}
                        </Box.Title>
                        <Box.Tools className='pull-right'>
                            <Button bsClass='bg-maroon btn' onClick={this.onPrintClick.bind(this)}><FontAwesome name='print' />&nbsp;พิมพ์เอกสาร</Button>&nbsp;
                            {doc.seq_no!==''?
                            <DropdownButton
                                bsStyle={'primary'}
                                title={'เปลี่ยนสถานะ'}
                                key={0}
                                id={'dropdown-invoice-status-menu-button'}
                                onSelect={this.onDropdownSelect.bind(this)}
                            >	      
                                <MenuItem eventKey="2"><FontAwesome name='money'/> จ่ายเงินแล้ว</MenuItem>
                                <MenuItem eventKey="3"><FontAwesome name='ban'/> ยกเลิก</MenuItem>
                                <MenuItem divider />
                                <MenuItem eventKey="4"><FontAwesome name='trash'/> ลบเอกสาร</MenuItem>
                            </DropdownButton> 
                            :''}
                        </Box.Tools>
                    </Box.Header>
                    <Box.Body>
                        {this.renderHeaderRow()}
                        {this.renderTable()}
                        {this.renderNewItemButton()}
                        {this.renderRemark()}
                    </Box.Body>
                    <Box.Footer>
                        <ButtonToolbar className='pull-right'>
                            <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
                            <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;ปิดเอกสาร</Button>
                        </ButtonToolbar>
                    </Box.Footer>
                </Box>
                <NotificationSystem ref="notificationSystem" />
                <IframeModal ref='iframe'  title={'พิมพ์เอกสาร'} />
                <RemarkRecordModal
                    show={this.state.showRemark}
                    docTitle='ลบใบงานซ่อมยางภายใน'
                    docName='tyrerepair'
                    docNo={trNo}
                    docTag=''
                    onModalClose={()=>{this.setState({showRemark:false})}}
                    onSuccess={this.onRemarkDeleteRecordClick.bind(this)}
                />
                <ConfirmPopup
                    show={this.state.showConfirm}
                    message={this.state.msgConfirm}
                    onConfirm={this.onConfirmClick.bind(this)}
                    onHide={()=>{this.setState({showConfirm:false,msgConfirm:''})}}
                />
                {this.renderAssetVehicleModal()}
            </div>
        )
    }
}

TyreRepairInsideDoc.defaultProps = {
        
}
      
export default TyreRepairInsideDoc;


// WEBPACK FOOTER //
// ./src/view/tyre/TyreRepairInsideDoc.js